'use client';

import dynamic from 'next/dynamic';
import { usePageReady } from '@/lib/late-widgets';

// The site-wide widgets nobody needs in the first second of a page: loaded
// once it is ready (lib/late-widgets.ts), in their own chunks. Telemetry is
// not among them - it catches the page's first errors - nor the sign-in
// dialog, already split, nor the impersonation banner, which sits in the flow
// at the top of the page.
const CookieConsent = dynamic(() => import('./CookieConsent'), { ssr: false });
const DialogHost = dynamic(() => import('./DialogHost'), { ssr: false });
const RatingHost = dynamic(() => import('./RatingHost'), { ssr: false });
const BackToTopButton = dynamic(() => import('./BackToTopButton'), { ssr: false });
const TitleTooltips = dynamic(() => import('./TitleTooltips'), { ssr: false });
const HintHost = dynamic(() => import('./HintHost'), { ssr: false });
const FieldTips = dynamic(() => import('./FieldTips'), { ssr: false });
const SelectPopup = dynamic(() => import('./SelectPopup'), { ssr: false });
const PwaRegistration = dynamic(() => import('./PwaRegistration').then((m) => m.PwaRegistration), { ssr: false });

export default function LateWidgets() {
  const ready = usePageReady();
  if (!ready) return null;
  return (
    <>
      <CookieConsent />
      <DialogHost />
      <RatingHost />
      <BackToTopButton />
      <TitleTooltips />
      <FieldTips />
      <SelectPopup />
      <HintHost />
      <PwaRegistration />
    </>
  );
}
